import axios from "axios";

const isLoopbackHost = (hostname = "") =>
  ["localhost", "127.0.0.1", "::1"].includes(hostname);

const isLoopbackURL = (value = "") => {
  try {
    return isLoopbackHost(new URL(value).hostname);
  } catch {
    return false;
  }
};

const getBaseURL = () => {
  const configuredBaseURL = process.env.REACT_APP_API_BASE_URL?.trim();

  if (configuredBaseURL) {
    if (typeof window === "undefined") {
      return configuredBaseURL;
    }

    if (!isLoopbackURL(configuredBaseURL)) {
      return configuredBaseURL;
    }

    if (isLoopbackHost(window.location.hostname)) {
      return configuredBaseURL;
    }

    return window.location.origin;
  }

  if (typeof window === "undefined") {
    return "http://localhost:3004";
  }

  const { hostname, origin } = window.location;

  if (isLoopbackHost(hostname)) {
    return "http://localhost:3004";
  }

  return origin;
};

const baseURL = getBaseURL();

const publicRequest = axios.create({
  baseURL,
});

export default publicRequest;
